// The Prakrit course's header: the shared Suvaani header (site-header.tsx) with the Prakrit sections, its command
// search and the shared Preferences sheet.

import type { FC, ReactNode } from 'react'
import type { SiteNavItem } from '@/components/app/site-header'

import { useEffect, useState } from 'react'
import { BookOpen, Dumbbell, FlaskConical, House, Library, ScrollText, TrendingUp } from 'lucide-react'
import { PRIMARY_NAV } from '@/constants/site'
import { CommandSearch } from '@/components/app/command-search'
import { SettingsMenu } from '@/components/app/settings-controls'
import { SiteHeader, SuvaaniMark, isCurrent } from '@/components/app/site-header'

const ICONS: Record<string, SiteNavItem['icon']> = {
    '/prakrit': House,
    '/learn': BookOpen,
    '/practice': Dumbbell,
    '/grammar': FlaskConical,
    '/vocabulary': Library,
    '/stories': ScrollText,
    '/progress': TrendingUp
}

const NAV: SiteNavItem[] = PRIMARY_NAV.map(item => ({
    href: item.href,
    label: item.en,
    icon: ICONS[item.href] ?? House,
    match: item.match
}))

/** Whether a Prakrit section is current (the bottom bar uses the same rule). */
export const isActive = (pathname: string, href: string, match?: string[]): boolean => isCurrent(pathname, { href, match })

/** The Prakrit product mark (footer, focus pages). */
export const Wordmark: FC<{ className?: string, small?: boolean }> = ({ className }): ReactNode => <SuvaaniMark course='prakrit' className={className} />

export const AppHeader: FC = (): ReactNode => {
    const [searchOpen, setSearchOpen] = useState(false)

    useEffect(() => {
        const onKey = (event: KeyboardEvent) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
                event.preventDefault()
                setSearchOpen(open => !open)
            }
        }

        window.addEventListener('keydown', onKey)

        return () => window.removeEventListener('keydown', onKey)
    }, [])

    return (
        <>
            <SiteHeader
                course='prakrit'
                nav={NAV}
                onSearch={() => setSearchOpen(true)}
                settings={<SettingsMenu />}
            />
            <CommandSearch open={searchOpen} onOpenChange={setSearchOpen} />
        </>
    )
}
